import axios from "axios";
import ConfigConnection from "../config/config.service";
export default class CandidateService {
  // API Instance
  configConnection: any = new ConfigConnection();

  private envTKN = this.configConnection.apiKey;

  get(startDate, endDate, reportedId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };

    const endDateQuery = startDate
      ? `&surveyEndMin=${startDate}&surveyEndMax=${endDate}`
      : "";
    const reporterQuery = reportedId ? `&admin=${reportedId}` : "";

    return axios.get(
      `${_.configConnection.apiInstance}candidate?${reporterQuery}${endDateQuery}`,
      config
    );
  }

  create(candidate) {
    const _ = this;
    console.log(candidate);
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}candidate`,
      candidate,
      config
    );
  }

  edit(user, userId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.put(
      `${_.configConnection.apiInstance}user/${userId}`,
      user,
      config
    );
  }

  getById(userId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}candidate/${userId}`,
      config
    );
  }

  getByJob(jobId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}job/${jobId}`, config);
  }

  delete_user(user_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.delete(
      `${_.configConnection.apiInstance}user/${user_id}`,
      config
    );
  }

  getCompanies() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}company`, config);
  }

  getJobs() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}job`, config);
  }

  getReporters() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}user/reporters`, config);
  }

  assingCompanies(user_id, company_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}user/${user_id}/company`,
      { company_id: company_id },
      config
    );
  }

  getInactive(pageOffset, itemsPerPage) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}user/candidate/inactive?offset=${pageOffset}&limit=${itemsPerPage}`,
      config
    );
  }

  active_user(user_id, reactivate) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}user/${user_id}/reactivate`,
      config
    );
  }

  getProfileReport(userSurveyId, profileId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}candidate/${userSurveyId}/report`,
      config
    );
  }

  getSingleReport(userSurveyId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}candidate/${userSurveyId}/report`,
      config
    );
  }

  downloadMonthlyReport(
    companyId: string,
    startDate: string,
    endDate: string,
    reportType: string,
    region: string
  ) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${this.envTKN}`,
      },
      responseType: 'blob',
    };

    let regionQuery = "";
    if (region !== "all") {
      regionQuery = `&reporter_id=${region}`;
    }

    return axios.get(
      `${_.configConnection.apiInstance}company/${companyId}/monthly-progress-report?start_date=${startDate}&end_date=${endDate}&report_type=${reportType}${regionQuery}`,
      config
    );
  }
}
